import React from "react";
import "./Launching.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMaximize } from "@fortawesome/free-solid-svg-icons";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { faBed } from "@fortawesome/free-solid-svg-icons";
import { faShower } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Soultan12 } from "./Soultan/Soultan";
import { Soultan15 } from "./Soultan/Soultan";
import { Soultan18 } from "./Soultan/Soultan";

const Launching = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const Soultan12wa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Soultan12)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const Soultan15wa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Soultan15)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const Soultan18wa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20rumah%20ini%20(Soultan18)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  return (
    <div className="newlaunch">
      <div className="judul-newlaunching">
        <h1>New Launching</h1>
      </div>
      <div className="container-card">
        <div className="kartu">
          <Slider {...settings}>
            {Soultan12.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Soultan Island 12</div>
              <div className="sub-judul-rumah">Surrounded by Lake</div>
              {/* <div className="cicilan">
                <div className="angka">9.5 Miliar</div>
              </div> */}
            </div>
          </div>
          {/* <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faMaximize} />
            <span> : 300m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 398m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 5+1</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 5+1</span>
          </div> */}
          <div className="containerwhatsapp">
            <button onClick={Soultan12wa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="kartu">
          <Slider {...settings}>
            {Soultan15.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Soultan Island 15</div>
              <div className="sub-judul-rumah">Surrounded by Lake</div>
              {/* <div className="cicilan">
                <div className="angka">13.6 Miliar</div>
              </div> */}
            </div>
          </div>
          {/* <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faMaximize} />
            <span> : 375m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 495m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 5+1</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 5+1</span>
          </div> */}
          <div className="containerwhatsapp">
            <button onClick={Soultan15wa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
        <div className="kartu">
          <Slider {...settings}>
            {Soultan18.map((image, index) => (
              <img
                className="kartugambar"
                key={index}
                src={image}
                alt={`Astha ${index + 1}`}
              />
            ))}
          </Slider>
          <div className="container-title-card">
            <div className="titlecard">
              <div className="judul-rumah">Soultan Island 18</div>
              <div className="sub-judul-rumah">Surrounded by Lake</div>
              {/* <div className="cicilan">
                <div className="angka">26.6 Miliar</div>
              </div> */}
            </div>
          </div>
          {/* <hr color="black" />
          <div className="gridspek">
            <FontAwesomeIcon icon={faMaximize} />
            <span> : 600m²</span>
            <FontAwesomeIcon icon={faHouse} />
            <span> : 747m²</span>
            <FontAwesomeIcon icon={faBed} />
            <span>: 5+2</span>
            <FontAwesomeIcon icon={faShower} />
            <span>: 5+1</span>
          </div> */}
          <div className="containerwhatsapp">
            <button onClick={Soultan18wa} className="whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Launching;
